import cx from 'classnames';

import Highlights from '@/vdp/VehicleInfo/Highlights';
import { useIsDealershipPage } from '~/context/dealership/StaticContext';
import BasicInfo from './BasicInfo';
import GetYourTerms from './GetYourTerms';
import Price from './Price';
import ShippingAndGetItBy from './ShippingAndGetItBy';
import Terms from './Terms';
import { VehicleInfoProvider } from './VehicleInfoContext';

type OwnProps = {
  enablePriceObserver?: boolean;
  isBannerShowing?: boolean;
  isCondensed?: boolean;
  showCtaFooter?: boolean;
  showOutOfAreaError?: boolean;
};

function getContentPaddingClasses(
  isBannerShowing: boolean,
  showOutOfAreaError: boolean,
  showCtaFooter: boolean
): string {
  const topPadding = isBannerShowing
    ? 'sm:pt-2xl lg:pt-3xl'
    : 'sm:pt-3xl lg:pt-4xl';

  const bottomPadding = showOutOfAreaError
    ? ''
    : showCtaFooter
    ? 'pb-2xl sm:pb-2xl lg:pb-3xl'
    : 'pb-2xl sm:pb-xl lg:pb-2xl';

  return cx(
    'flex flex-col gap-2xl px-2xl py-xl sm:px-3xl lg:px-4xl',
    topPadding,
    bottomPadding
  );
}

export function VehicleInfo() {
  const isDealership = useIsDealershipPage();

  return (
    <div className="flex w-full flex-col gap-xl sm:gap-2xl">
      <BasicInfo />
      <div className="flex flex-col gap-xl">
        <div className="grid justify-items-start gap-md md:gap-xl">
          <div className="w-full">
            <div className="flex w-full items-end justify-between gap-x-xl">
              <Price />
              <GetYourTerms />
            </div>
            <Highlights />
          </div>
          <Terms />
        </div>
        {!isDealership && <ShippingAndGetItBy />}
      </div>
    </div>
  );
}

export default function VehicleInfoWrapper({
  isBannerShowing = false,
  showCtaFooter = false,
  showOutOfAreaError = false,
  ...contextProps
}: OwnProps) {
  return (
    <div
      className={getContentPaddingClasses(
        isBannerShowing,
        showOutOfAreaError,
        showCtaFooter
      )}
    >
      <VehicleInfoProvider value={contextProps}>
        <VehicleInfo />
      </VehicleInfoProvider>
    </div>
  );
}
